import React, { useEffect, useState } from "react";
import "./index.css";
import newLogo from "../../../../assets/images/newLogo.png";
import { Form, Input } from "antd";
import axios from "axios";
import { switchEndpoint } from "../../../../redux/actions/endpoints";
import { toast } from "react-toastify";
import { storage } from "../../../../scopedStorage";

const CollectionsLogin = (props) => {
  const [loading, setLoading] = useState(false);
  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  });

  // const [loginData, setLoginData] = useState({
  //   email: "testcheck@mailinator.com",
  //   password: "Ol@s@nm1",
  // });

  // const [loginData, setLoginData] = useState({
  //   email: "idowujulius92@gmail.com",
  //   password: "julipels",
  // });


  

  const handleLoginForm =
    (name) =>
      ({ target }) => {
        setLoginData({
          ...loginData,
          [name]: target.value,
        });
      };

  let payload = {
    email: loginData.email,
    password: loginData.password,
  };

  const handleLogin = async () => {
    setLoading(true);

    try {
      const response = await axios.post(`${switchEndpoint}/auth/login-email`, payload);
      const { customer, message, token } = response.data;

      if (customer.roles[0] === "collection_center") {
        const storageItems = {
          title: "Dashboard",
          token,
          centerInfo: JSON.stringify(customer),
          center: customer.collection_center.name,
          state_id: customer.collection_center.state_id,
          expireTime: Date.now(),
          manual_pricing: customer.collection_center.manual_pricing,
          use_state_pricing: customer.collection_center.use_state_pricing,
        };

        // storage.setItem scopes each session key (token, centerInfo, ...) to
        // this app automatically; "title" isn't a scoped key so it passes
        // through unprefixed, same as before.
        Object.entries(storageItems).forEach(([key, value]) => {
          storage.setItem(key, value);
        });

        toast.success(message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          progress: undefined,
          theme: "light",
        });

        props.history.push("/dashboards");
      } else {
        toast.error("Unauthorized", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          progress: undefined,
          theme: "light",
        });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        pauseOnHover: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      setLoading(false);
    }
  };

  const validate = () => {
    if (!loginData.email) {
      toast.error("Email not provided !", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        pauseOnHover: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    if (!loginData.password) {
      toast.error("Password not provided !", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        pauseOnHover: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    handleLogin();
  };

  useEffect(() => {
    storage.clearScoped();
  }, []);

  return (
    <div>
      <div className="row noMarginPadding">
        <div className="col-xl-6 col-lg-8 col-md-8 col-sm-8 col-xs-12 PaddingLeft-10">
          <div className="container pl-4 pt-4 PaddingLeft-10">
            <div style={{ width: "150px" }}>
              <img src={newLogo} alt="logo" style={{ width: "100%" }} />
            </div>
            <div className="w-75 ml-5 mt-5 containerWidth">
              <h5 className="headerText headerh5">Collection Center</h5>
              <p className="loginStyle mb-0">Login</p>
              <div className="form-group">
                <label className="label-control mb-0 labelStyle">
                  Email Address
                </label>
                <input
                  type="email"
                  className="form-control inputStyle"
                  placeholder="Enter email address"
                  value={loginData.email}
                  onChange={handleLoginForm("email")}
                />
              </div>
              <div>
                <label className="label-control mb-0 labelStyle">
                  Enter Password
                </label>
                <Form>
                  <Form.Item
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: "Please input your password!",
                      },
                    ]}
                    value={loginData.password}
                    onChange={handleLoginForm("password")}
                  >
                    <Input.Password placeholder="*************" />
                  </Form.Item>
                </Form>
              </div>

              <div className="forgotPassword">
                <div></div>
                <div className="fpw">
                  <a
                    href="/collection/forgotPassword"
                    style={{ color: "#231F20", fontSize: "13px" }}
                  >
                    Forgot Password{" "}
                    <span style={{ color: "#c4da00" }}>&#62;</span>
                  </a>
                </div>
              </div>

              <button
                type="button"
                className="btn loginBtn btn-sm btn-block"
                onClick={validate}
                disabled={loading}
              >
                Login
              </button>
            </div>
          </div>
        </div>
        <div className="col-xl-6 col-lg-4 col-md-4 rightImg"></div>
      </div>
    </div>
  );
};

export default CollectionsLogin;
